// extracted by mini-css-extract-plugin
export default {"form":"AddAdmin_form__qLyd8","buttonItem":"AddAdmin_buttonItem__r55L8"};